<template>
  <div class="container">
    <div class="bindWrap">
      <p class="pb22 fs16 fwb">{{ $t("account.password.password") }}</p>
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="0px" class="msContent">
        <el-form-item prop="oldPassword">
          <el-input type="password" :placeholder="$t('account.password.oldPassword')" v-model="passwordForm.oldPassword" show-password class="fl mr12 wd360"></el-input>
          <p class="fl">
            <router-link to="/forget" class="blue">{{ $t("login.forget") }}?</router-link>
          </p>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" :placeholder="$t('account.password.newPassword')" v-model="passwordForm.password" show-password class="wd360"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input type="password" :placeholder="$t('account.password.confirmPassword')" v-model="passwordForm.confirmPw" show-password class="wd360"></el-input>
        </el-form-item>
        <div class="wdb100 login-btn">
          <el-button type="primary" @click="submitForm('passwordForm')">{{ $t("account.password.change") }}</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { postRequest } from "@/api/common";
import { regularObj } from "@/utils/common";
import { mapGetters } from "vuex";
export default {
  name: "ChangePassword",
  data() {
    return {
      clickSwitch: true, // 防止恶意提交
      passwordForm: {
        oldPassword: null,
        password: null,
        confirmPw: null,
      },
      passwordRules: {
        oldPassword: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
          {
            pattern: regularObj.password,
            message: this.$t("common.regular.password"),
            trigger: "submit",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
          {
            pattern: regularObj.password,
            message: this.$t("common.regular.password"),
            trigger: "submit",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
  },
  methods: {
    // 修改 - 按钮
    submitForm(passwordForm) {
      this.$refs[passwordForm].validate(valid => {
        if (valid) {
          if (this.passwordForm.password != this.passwordForm.confirmPw) {
            this.$message.warning(this.$t("account.password.inconformity"));
            return false;
          }

          if (this.clickSwitch) {
            this.clickSwitch = false;
            postRequest("/member/changePwd", {
              oldPassword: this.passwordForm.oldPassword,
              password: this.passwordForm.password,
            })
              .then(res => {
                this.$message({
                  message: this.$t("common.success.change"),
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    this.$router.push("/account");
                  },
                });
              })
              .catch(err => {
                this.clickSwitch = true;
              });
          }
        } else {
          return false;
        }
      });
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped></style>
